/**
 * Scrolled state for the site header (Views/Partials/Header.cshtml).
 *
 * The header is transparent over the hero and turns into a solid white bar once the page has
 * scrolled past 100px. All this does is toggle `data-scrolled`; the styling that hangs off it
 * lives in the markup, so there is nothing here to keep in sync with the design.
 *
 * Uses ScrollTrigger rather than a scroll listener so the threshold is measured against the
 * same scroller ScrollSmoother installs.
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const header = document.querySelector("[data-site-header]");

if (header) {
    ScrollTrigger.create({
        // Absolute scroll positions: active from 100px down to the end of the page.
        start: 100,
        end: "max",
        onToggle: ({ isActive }) => header.toggleAttribute("data-scrolled", isActive),
    });
}
